<template>
<div>
    <v-card
        v-for="(inbox_url, index) in profile.organization_account.inbox_urls"
        :key="index"
        style="margin-bottom: 15px;"
    >
        <v-card-title>Webchat URL ({{index+1}})</v-card-title>

        <v-card-text>

            <m-edit-select
                    label="Domain Name"
                    :value="getDomainObject(inbox_url.url_matcher.domain)"
                    :possible_values="domains"
                    :read_only="read_only"
                    v-on:input="setDomain($event,index)"
                />

            <m-edit-text
                label="Path"
                :value="inbox_url.url_matcher.path_matcher.pattern"
                v-on:input="setPathMatcher($event,index)"
                :read_only="read_only"
                hint="Use * as a wildcard (will match any string), use {index-page} to match the home page only, use {empty-path} to match only the empty path, use not: to invert the matching (you can seperate multiple paths using spaces)"
                
            />

            <v-select
                label="Widget Settings"
                :value="getWidgetSettingsId(inbox_url)"
                :items="getWidgetSettingsChoices()"
                v-on:change="onChangeWidgetSettings($event, index)"
            />

            <m-edit-chip
                label="Inboxes"
                dialog_title="Inboxes to show at this URL"
                :value="getSelectedInboxes(inbox_url)"
                :possible_values="inbox_choices"
                :read_only="read_only"
                v-on:input="setSelectedInboxes($event,index)"
            />

            

        </v-card-text>

        <div
            style="position: absolute; right: 20px; top: 20px;"
        >
            <v-menu 
                bottom 
                offset-y  
            >

                <template v-slot:activator="{ on }">
                    
                    <v-icon
                        v-on="on"
                        color="primary"
                    >
                        mdi-dots-vertical
                    </v-icon>
                    
                </template>

                <v-list>
                    <v-list-item
                        :disabled="index == 0"
                        v-on:click="move(index,true)"
                    >
                        <v-list-item-title>Move Up</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :disabled="index == profile.organization_account.inbox_urls.length-1"
                        v-on:click="move(index,false)"
                    >
                        <v-list-item-title>Move Down</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-on:click="newURL(index, true)"
                    >
                        <v-list-item-title>New URL before</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="newURL(index, false)"
                    >
                        <v-list-item-title>New URL after</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-on:click="deleteURL(index)"
                    >
                        <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>


                </v-list>

            </v-menu>


        </div>

    </v-card>

    <v-row>
        <v-col>
        </v-col>

        <v-col
            class='flex-grow-0'
        >
            <v-btn 
                class="mx-2" fab dark small color="primary"
                v-on:click="addURL()"
            >
                <v-icon dark>mdi-plus</v-icon>
            </v-btn>
        </v-col>
    </v-row>


</div>
</template>

<script>
const _ = require('lodash');
let domain_any = { 'text' : 'Any domain', 'domain' : '*' };

let default_new_url = { 
    "url_matcher": { 
        "domain": null, 
        "path_matcher": { 
            "case_sensitive": false, 
            "pattern": "*" 
        } 
    }, 
    "inbox_ids": [] 
};

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    data() {
        return {
            domains: [],
            inbox_choices: [],
        }
    },

    mounted () 
    {
        let my_domains = [
            domain_any
        ];

        for ( let i = 0; i < this.profile.owned_domains.length; i++ )
        {
            my_domains.push(
                { 'text' : this.profile.owned_domains[i].domain, 'domain' : this.profile.owned_domains[i].domain }
            );
        }

        this.domains = my_domains;

        
        this.$rc.rest(
            'LIST: /api/v1/inboxes',
        
            {
                'organization_id': this.profile.organization_id,
                'is_archived': false,
            },
        
            (data) => {
                let inboxes = data.results;

                let inbox_choices = [];

                for ( let i = 0; i < inboxes.length; i++ )
                {
                    inbox_choices.push({
                        'text' : inboxes[i].internal_label,
                        'inbox_id' : inboxes[i].inbox_id,
                    });
                }

                this.inbox_choices = inbox_choices;
    
            },
        
            () => {
                this.$rc.alert('Error','Unable to list inboxes');
            },
        );
    },

    methods: {

        getDomainObject(domain_value)
        {
            let domains = this.domains;
            for ( let i = 0; i < domains.length; i++ )
            {
                if ( domains[i].domain == domain_value )
                    return domains[i];
            }
            return domain_any;
        },

        setDomain(domain_obj, index)
        {
            let inbox_urls = _.cloneDeep(this.profile.organization_account.inbox_urls);
            let domain = domain_obj.domain;

            if ( domain == '*' )
                domain = null;

            inbox_urls[index].url_matcher.domain = domain;
            this.$emit('update-urls',inbox_urls);
        },

        setPathMatcher(new_path_matcher, index)
        {
            let inbox_urls = _.cloneDeep(this.profile.organization_account.inbox_urls);
            inbox_urls[index].url_matcher.path_matcher.pattern = new_path_matcher;

            this.$emit('update-urls',inbox_urls);
        },

        setSelectedInboxes(new_selected_inboxes, index)
        {
            let inbox_urls = _.cloneDeep(this.profile.organization_account.inbox_urls);

            let new_ids = [];
            for ( let i = 0; i < new_selected_inboxes.length; i++ )
            {
                new_ids.push(new_selected_inboxes[i].inbox_id);
            }

            inbox_urls[index].inbox_ids = new_ids;
            this.$emit('update-urls',inbox_urls);
        },

        newURL(index, is_before)
        {
            let inbox_urls = _.cloneDeep(this.profile.organization_account.inbox_urls);

            let new_index = index;

            if ( !is_before )
                new_index++;

            inbox_urls.splice(new_index, 0, _.cloneDeep(default_new_url));

            this.$emit('update-urls',inbox_urls);
        },

        addURL()
        {
            let inbox_urls = _.cloneDeep(this.profile.organization_account.inbox_urls);
            inbox_urls.push(_.cloneDeep(default_new_url));
            this.$emit('update-urls',inbox_urls);
        },

        move(index, move_up)
        {
            let inbox_urls = _.cloneDeep(this.profile.organization_account.inbox_urls);

            let other_index = index-1;

            if( !move_up )
                other_index = index+1;

            if ( other_index < 0 ) return;
            if ( other_index >= inbox_urls.length ) return;

            let at_index = inbox_urls[index];
            let at_other_index = inbox_urls[other_index];

            inbox_urls[index] = at_other_index;
            inbox_urls[other_index] = at_index;

            this.$emit('update-urls',inbox_urls);
        },

        deleteURL(index)
        {
            let inbox_urls = _.cloneDeep(this.profile.organization_account.inbox_urls);
            inbox_urls.splice(index, 1);
            this.$emit('update-urls',inbox_urls);
        },

        getSelectedInboxes(inbox_url)
        {
            let inbox_choices = this.inbox_choices;

            let ret = [];

            for ( let i = 0; i < inbox_choices.length; i++ )
            {
                if ( inbox_url.inbox_ids.includes(inbox_choices[i].inbox_id) )
                    ret.push(inbox_choices[i]);
            }

            return ret;
        },

        getWidgetSettingsId(inbox_url) {
           if ( inbox_url.widget_settings_id == null )
                return this.profile.organization_id;

            return inbox_url.widget_settings_id;
        },

        getWidgetSettingsChoices()
        {
            let ret = [];

            for ( let i = 0; i < this.profile.widget_settings.length; i++ )
            {
                let cur = this.profile.widget_settings[i];

                ret.push({
                    'text' : cur.label,
                    'value' : cur.settings_id,
                });
            }

            return ret;
        },

        onChangeWidgetSettings(new_id, index)
        {
            let inbox_urls = _.cloneDeep(this.profile.organization_account.inbox_urls);

            inbox_urls[index].widget_settings_id = new_id;
            this.$emit('update-urls',inbox_urls);
        },

    },

    computed: {
        read_only() {
            return !this.profile.actor_permissions.can_write; 
        },
    },
}
</script>

<style lang="scss" scoped>

</style>